import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IDoorData } from "common/records/Door";

export const RECEIVE_DOOR = "@doors/RECEIVE_DOOR";
export const RECEIVE_DRAFT_DOOR = "@doors/RECEIVE_DRAFT_DOOR";
export const RESET_DOOR = "@doors/RESET_DOOR";

export const DoorActions = {
  receiveDoor: (door: Partial<IDoorData>) => createAction(RECEIVE_DOOR, { door }),
  /** Upsert a draft door into byId only (no lastSavedById), so reset can drop/revert it. */
  receiveDraftDoor: (door: Partial<IDoorData>) => createAction(RECEIVE_DRAFT_DOOR, { door }),
  resetDoor: (doorId: number) => createAction(RESET_DOOR, { doorId }),
};

export type DoorActions = ActionsUnion<typeof DoorActions>;
